"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _lib = require("../../../lib");
var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _makeStyles["default"])(function (theme) {
  return {
    root: {
      "& .MuiOutlinedInput-root": {
        borderRadius: 20,
        paddingBottom: "4px!important",
        paddingRight: "6px!important"
      }
    }
  };
});
var BoatOption = function BoatOption(_ref) {
  var boat = _ref.boat,
    onBoatSelect = _ref.onBoatSelect;
  var _useBoatLowestPrice = (0, _lib.useBoatLowestPrice)(boat),
    lowestPrice = _useBoatLowestPrice.price;
  return /*#__PURE__*/_react["default"].createElement(_material.Link, {
    onClick: function onClick() {
      return onBoatSelect(boat);
    },
    color: "textSecondary"
  }, boat.name, " from ($", lowestPrice, ")");
};
function BoatSearch(_ref2) {
  var boats = _ref2.boats,
    onBoatSelect = _ref2.onBoatSelect;
  var _useStyles = useStyles(),
    root = _useStyles.root;
  var orderBoats = (0, _react.useMemo)(function () {
    return boats.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  }, [boats]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      width: "100%",
      maxWidth: 280
    },
    pt: 0.5,
    mb: 0.5
  }, /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], {
    disablePortal: true,
    id: "boat-search",
    size: "small",
    options: orderBoats,
    className: root,
    noOptionsText: "No Boat Found",
    getOptionLabel: function getOptionLabel(option) {
      return option.name || "";
    },
    onChange: function onChange(_, boat) {
      if (boat) onBoatSelect(boat);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_material.TextField, _extends({}, params, {
        variant: "outlined",
        label: "Search Boat Name",
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          endAdornment: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
            position: "start"
          }, /*#__PURE__*/_react["default"].createElement(_Search["default"], null)))
        })
      }));
    },
    renderOption: function renderOption(props, option) {
      return /*#__PURE__*/_react["default"].createElement("li", props, /*#__PURE__*/_react["default"].createElement(BoatOption, {
        boat: option,
        onBoatSelect: onBoatSelect
      }));
    }
  }));
}
BoatSearch.propTypes = {
  Boats: _propTypes["default"].arrayOf(_propTypes["default"].object)
};
var _default = exports["default"] = BoatSearch;